import React from 'react'
import Card from '../components/Card'

export default function FAQ() {
  return (
    <div className="container">
      <section className="card">
        <h2 className="h2">Frequently asked questions</h2>

        <div style={{marginTop:12}}>
          <Card><div style={{fontWeight:700}}>How do I get matched?</div><div className="kv" style={{marginTop:8}}>Search or request a match — then review profiles and request service.</div></Card>
          <Card style={{marginTop:12}}><div style={{fontWeight:700}}>Are my documents secure?</div><div className="kv" style={{marginTop:8}}>Yes — uploads are encrypted in transit and at rest.</div></Card>
          <Card style={{marginTop:12}}><div style={{fontWeight:700}}>How do payments work?</div><div className="kv" style={{marginTop:8}}>Payments are processed via Stripe; we support platform fees and payouts to pros.</div></Card>
        </div>
      </section>
    </div>
  )
}
